import { useState } from "react";
import "./WhatsNewModal.css";

const LS_KEY = "stormatlas_hide_whats_new";

export default function WhatsNewModal() {
  const [visible, setVisible] = useState(
    () => localStorage.getItem(LS_KEY) !== "1"
  );
  const [dontShow, setDontShow] = useState(false);

  if (!visible) return null;

  const handleClose = () => {
    if (dontShow) localStorage.setItem(LS_KEY, "1");
    setVisible(false);
  };

  return (
    <div className="wn-backdrop" onClick={handleClose}>
      <div className="wn-modal" role="dialog" aria-modal="true" aria-label="What's New" onClick={(e) => e.stopPropagation()}>
        <button
          className="wn-close"
          onClick={handleClose}
          aria-label="Close"
        >
          <svg viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>

        <h2 className="wn-title">What's New in StormAtlas</h2>
        <p className="wn-body">
          StormAtlas is evolving fast. Dual-pane radar comparison, velocity
          products, and major performance upgrades are here — with more on the
          way, including O.R.A., an AI-powered severe weather assistant.
        </p>
        <p className="wn-body">
          I'm building this solo because I believe chasers and weather
          enthusiasts deserve a faster, smarter radar platform. Thank you for
          being part of this early.
        </p>
        <p className="wn-sig">— Jonathan</p>

        <label className="wn-toggle">
          <input
            type="checkbox"
            checked={dontShow}
            onChange={(e) => setDontShow(e.target.checked)}
          />
          <span>Do not show again</span>
        </label>
      </div>
    </div>
  );
}
